import { render, staticRenderFns } from "./CustomerPromocodeCreate.vue?vue&type=template&id=8e51e56a"
import script from "./CustomerPromocodeCreate.vue?vue&type=script&lang=js"
export * from "./CustomerPromocodeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports